<script>
import { currentTrainingForms } from '@app/mixins/forms';
import CustomFieldsCrudList from '@app/components/CustomFieldsCrudList.vue';

export default {
  mixins: [currentTrainingForms],
  components: { CustomFieldsCrudList },
  data: () => ({
    options: {
      enabled: false,
      fields: [],
    },
  }),
  created() {
    const opts = this.currentTraining && this.currentTraining.custom_fields_options;
    if (opts) {
      this.options = {
        enabled: !!opts.enabled,
        fields: Array.isArray(opts.fields)
          ? opts.fields.map((f) => ({
            name: f.name,
            label: f.label,
            type: f.type,
            required: !!f.required,
            options: Array.isArray(f.options) ? [...f.options] : [],
          }))
          : [],
      };
    }
  },
  methods: {
    handle(newOptions) {
      this.options = newOptions;
      this.isLoading = true;
      return this.$store.dispatch('trainings/updateCustomFields', {
        uuid: this.currentTraining.uuid,
        customFieldsOptions: newOptions,
        isCurrent: true,
      })
        .then(() => this.$showMessage.success())
        .catch((err) => {
          const errors = err.response?.data?.errors;
          if (errors && typeof errors === 'object') {
            const messages = Object.values(errors).flat().join('<br>');
            this.$showMessage.error(messages);
          } else {
            this.$showMessage.error();
          }
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <AppFeatureWrapper>
    <template #title>
      Récoltez des informations
      <AppFeatureBadge class="ml-2" position="is-right" planLock="EXPERT" />
    </template>
    <template #content>
      <p>
        Ajoutez des questions personnalisées qui s'afficheront
        au démarrage de cette formation.
      </p>
      <p>
        Utilisez ces informations pour cerner le profil
        de vos apprenants et adapter vos contenus en fonction de leurs réponses.
      </p>
      <p>
        Attention aux informations que vous demandez :
        la collecte de données sensibles est interdite et reste sous votre entière responsabilité,
        conformément à notre politique de confidentialité.
      </p>
    </template>
    <template #form>
      <div class="box is-relative">
        <GoProWrapper planLock="EXPERT" :hasSep="false">
          <CustomFieldsCrudList
            v-model="options"
            :is-loading="isLoading"
            @save="handle"
          />
        </GoProWrapper>
      </div>
    </template>
  </AppFeatureWrapper>
</template>
